import { render, staticRenderFns } from "./AgentDetails.vue?vue&type=template&id=15b1c692&scoped=true&"
import script from "./AgentDetails.vue?vue&type=script&lang=js&"
export * from "./AgentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AgentDetails.vue?vue&type=style&index=0&id=15b1c692&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1c692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b1c692')) {
      api.createRecord('15b1c692', component.options)
    } else {
      api.reload('15b1c692', component.options)
    }
    module.hot.accept("./AgentDetails.vue?vue&type=template&id=15b1c692&scoped=true&", function () {
      api.rerender('15b1c692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/AgentDetails.vue"
export default component.exports